module.exports = __webpack_public_path__ + "img/uni-eth-usdc.e37b6101.svg";